var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDropDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5H19.5V22.5H13.5V25.5ZM13.5 13.5H30V10.5H13.5V13.5ZM13.5 19.5H30V16.5H13.5V19.5ZM33.75 1.5H11.25C9.85761 1.5 8.52226 2.05312 7.53769 3.03769C6.55313 4.02226 6 5.35761 6 6.75V41.25C6 42.6424 6.55313 43.9777 7.53769 44.9623C8.52226 45.9469 9.85761 46.5 11.25 46.5H28.7662C27.5781 45.6809 26.5371 44.6665 25.6875 43.5H11.25C10.6533 43.5 10.081 43.2629 9.65901 42.841C9.23705 42.419 9 41.8467 9 41.25V6.75C9 6.15326 9.23705 5.58097 9.65901 5.15901C10.081 4.73705 10.6533 4.5 11.25 4.5H33.75C34.3467 4.5 34.919 4.73705 35.341 5.15901C35.7629 5.58097 36 6.15326 36 6.75V23.25C37.0106 23.2497 38.0176 23.3693 39 23.6062V6.75C39 5.35761 38.4469 4.02226 37.4623 3.03769C36.4777 2.05312 35.1424 1.5 33.75 1.5Z",
    fill: "url(#paint0_linear_822_10054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25.5C33.9233 25.5 31.8932 26.1158 30.1665 27.2696C28.4398 28.4233 27.094 30.0632 26.2993 31.9818C25.5045 33.9004 25.2966 36.0116 25.7018 38.0484C26.1069 40.0852 27.1069 41.9562 28.5754 43.4246C30.0438 44.8931 31.9148 45.8931 33.9516 46.2982C35.9884 46.7034 38.0996 46.4955 40.0182 45.7007C41.9368 44.906 43.5767 43.5602 44.7304 41.8335C45.8842 40.1068 46.5 38.0767 46.5 36C46.5 33.2152 45.3937 30.5445 43.4246 28.5754C41.4555 26.6062 38.7848 25.5 36 25.5ZM31.875 29.25H40.125V31.5H31.875V29.25ZM40.4681 37.6144C40.4377 37.6889 40.3858 37.7528 40.3191 37.7979C40.2523 37.8429 40.1737 37.8672 40.0931 37.8675H38.4562V42C38.4558 42.1083 38.4125 42.2119 38.336 42.2885C38.2594 42.365 38.1558 42.4083 38.0475 42.4087H33.9544C33.8461 42.4083 33.7424 42.365 33.6659 42.2885C33.5893 42.2119 33.5461 42.1083 33.5456 42V37.875H31.9087C31.828 37.8749 31.7491 37.8509 31.682 37.8059C31.6148 37.761 31.5625 37.6972 31.5316 37.6226C31.5008 37.548 31.4927 37.4659 31.5084 37.3867C31.5241 37.3074 31.563 37.2347 31.62 37.1775L35.7113 33.0844C35.7887 33.0087 35.8927 32.9663 36.0009 32.9663C36.1092 32.9663 36.2132 33.0087 36.2906 33.0844L40.3819 37.1775C40.4376 37.2338 40.4755 37.3053 40.4908 37.3829C40.5061 37.4606 40.4983 37.5411 40.4681 37.6144Z",
    fill: "url(#paint1_linear_822_10054)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_822_10054",
    x1: 6,
    y1: 1.5,
    x2: 34.8113,
    y2: 49.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272135,
    stopColor: "#412A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658079,
    stopColor: "#34263B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_822_10054",
    x1: 26.0494,
    y1: 27.1481,
    x2: 43.3519,
    y2: 44.4506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7052D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CA5AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropDoc);
export default __webpack_public_path__ + "static/media/ic_drop_doc.385078a8e1a0c53cc1a0ded0f86ffa6e.svg";
export { ForwardRef as ReactComponent };